import {
  PaymentCreditActionTypes,
  PaymentCreditActions,
} from './payment-credit.actions';
import { IPaymentCreditFormCC, IPaymentCreditFormExt } from '../../../commons';

export interface State {
  error: string | null;
  pending: boolean;

  stateFormCCData: IPaymentCreditFormCC | null;
  stateProcessedFormCCData: IPaymentCreditFormCC | null;

  stateFormCGData: IPaymentCreditFormExt | null;
  stateProcessedFormCGData: IPaymentCreditFormExt | null;

  stateFormPPData: IPaymentCreditFormExt | null;
  stateProcessedFormPPData: IPaymentCreditFormExt | null;

  stateFormESData: IPaymentCreditFormExt | null;
  stateProcessedFormESData: IPaymentCreditFormExt | null;

  // stateFormCIData: IPaymentCreditFormExt | null;
  // stateProcessedFormCIData: IPaymentCreditFormExt | null;
}

export const initialState: State = {
  error: null,
  pending: false,

  stateFormCCData: null,
  stateProcessedFormCCData: null,

  stateFormCGData: null,
  stateProcessedFormCGData: null,

  stateFormPPData: null,
  stateProcessedFormPPData: null,

  stateFormESData: null,
  stateProcessedFormESData: null,

  // stateFormCIData: null,
  // stateProcessedFormCIData: null,
};

export function reducer(
  state = initialState,
  action: PaymentCreditActions
): State {
  switch (action.type) {
    // case PaymentCreditActionTypes.LoadPaymentCreditFormCIState:
    // case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCIState:

    case PaymentCreditActionTypes.LoadPaymentCreditFormCCState:
    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCCState:
    case PaymentCreditActionTypes.LoadPaymentCreditFormCGState:
    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCGState:
    case PaymentCreditActionTypes.LoadPaymentCreditFormESState:
    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormESState:
    case PaymentCreditActionTypes.LoadPaymentCreditFormPPState:
    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormPPState: {
      return {
        ...state,
        pending: true,
      };
    }

    case PaymentCreditActionTypes.LoadPaymentCreditFormCCStateSuccess: {
      return {
        ...state,
        pending: [
          state.stateFormCGData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateProcessedFormCGData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateProcessedFormCCData,
        ].some((s) => s === null),
        stateFormCCData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCCStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateProcessedFormCGData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateFormCGData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateFormCCData ].some((s) => s === null),
        stateProcessedFormCCData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadPaymentCreditFormCGStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateFormCCData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateProcessedFormCGData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateProcessedFormCCData].some((s) => s === null),
        stateFormCGData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCGStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateProcessedFormCCData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateFormCGData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateFormCCData].some((s) => s === null),
        stateProcessedFormCGData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadPaymentCreditFormPPStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateFormCCData,
          state.stateFormESData,
          state.stateProcessedFormCGData,
          state.stateProcessedFormCGData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateProcessedFormCCData].some((s) => s === null),
        stateFormPPData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormPPStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateProcessedFormCCData,
          state.stateProcessedFormESData,
          state.stateProcessedFormCGData,
          state.stateFormCGData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateFormCCData].some((s) => s === null),
        stateProcessedFormPPData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadPaymentCreditFormESStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateFormCCData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateProcessedFormCGData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateProcessedFormCCData].some((s) => s === null),
        stateFormESData: action.payload,
      };
    }

    case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormESStateSuccess: {
      return {
        ...state,
        pending:
          [state.stateProcessedFormCCData,
          state.stateProcessedFormESData,
          state.stateProcessedFormPPData,
          state.stateFormCGData,
          state.stateFormESData,
          state.stateFormPPData,
          state.stateFormCCData].some((s) => s === null),
        stateProcessedFormESData: action.payload,
      };
    }

    case PaymentCreditActionTypes.ProcessFormCCAsCredit:
    case PaymentCreditActionTypes.ProcessFormExtAsCredit: {
      return {
        ...state,
        error: 'Success',
        pending: true,
      };
    }

    case PaymentCreditActionTypes.LoadPaymentCreditStateFail: {
      return {
        ...state,
        error: action.payload,
        pending: false,
      };
    }

    case PaymentCreditActionTypes.PaymentCreditScreenErrorReset: {
      return {
        ...state,
        error: null,
        pending: false,
      };
    }

    case PaymentCreditActionTypes.LoadPaymentCreditInitState: {
      state = initialState;
      return state;
    }

    default: {
      return state;
    }
  }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;

export const getStateFormCCData = (state: State) => state.stateFormCCData;
export const getStateProcessedFormCCData = (state: State) =>
  state.stateProcessedFormCCData;

export const getStateFormCGData = (state: State) => state.stateFormCGData;
export const getStateProcessedFormCGData = (state: State) =>
  state.stateProcessedFormCGData;

export const getStateFormPPData = (state: State) => state.stateFormPPData;
export const getStateProcessedFormPPData = (state: State) =>
  state.stateProcessedFormPPData;

export const getStateFormESData = (state: State) => state.stateFormESData;
export const getStateProcessedFormESData = (state: State) =>
  state.stateProcessedFormESData;

// export const getStateFormCIData = (state: State) => state.stateFormCIData;
// export const getStateProcessedFormCIData = (state: State) => state.stateProcessedFormCIData;

// case PaymentCreditActionTypes.LoadPaymentCreditFormCIStateSuccess: {
//     return {
//         ...state,
//         pending: state.stateFormCCData, state.stateFormCGData, state.stateFormPPData,
//             state.stateProcessedFormCGData, state.stateProcessedFormCIData, state.stateProcessedFormPPData, state.stateProcessedFormCCData].some((s) => s === null),
//         stateFormCIData: action.payload
//     };
// }

// case PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCIStateSuccess: {
//     return {
//         ...state,
//         pending: state.stateProcessedFormCCData, state.stateProcessedFormCGData, state.stateProcessedFormPPData,
//             state.stateFormCGData, state.stateFormCIData, state.stateFormPPData, state.stateFormCCData].some((s) => s === null),
//         stateProcessedFormCIData: action.payload
//     };
// }
